import { render, staticRenderFns } from "./QrCodeLoader.vue?vue&type=template&id=21bc5067&scoped=true"
import script from "./QrCodeLoader.vue?vue&type=script&lang=js"
export * from "./QrCodeLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc5067",
  null
  
)

export default component.exports